<template>
  <div class="products">
    <!-- 导航栏 -->
    <Navbar :entName="entName" :logo="logo" />

    <!-- 页面 Banner -->
    <section class="page-banner">
      <div class="container">
        <h1>产品展示</h1>
        <p>丰富的产品线，为不同行业提供一站式解决方案</p>
      </div>
    </section>

    <!-- 页面内容 -->
    <section class="products-content">
      <div class="container">
        <div class="products-grid">
          <div
            class="product-card"
            v-for="product in products"
            :key="product.id"
          >
            <div class="product-image">
              <img :src="product.img" :alt="product.title" />
            </div>
            <h3>{{ product.title }}</h3>
            <p>{{ product.contentSimple }}</p>
            <router-link
              :to="`/product/productDetail?id=${product.id}`"
              class="btn"
              >查看详情</router-link
            >
          </div>
          <div v-if="products.length === 0" class="product-card">
            <div class="product-image">
              <img src="@/assets/1.png" alt="出海智能营销管理平台" />
            </div>
            <h3>出海智能营销管理平台</h3>
            <p>
              产品基于AI与SaaS技术一站式海外智能营销平台，覆盖营销全链条、全场景的工具体系，实现全链路闭环，帮助企业快速打开海外市场，降低运营成本、提升效率，驱动业务高速增长。
            </p>
            <router-link to="/product/ProductCHDetail" class="btn"
              >查看详情</router-link
            >
          </div>
          <div v-if="products.length === 0" class="product-card">
            <div class="product-image">
              <img src="@/assets/2.png" alt="企业管理与业务软件" />
            </div>
            <h3>企业管理与业务软件</h3>
            <p>
              数字化转型下，办公与生产力软件从工具走向业务赋能。它们整合项目、人事、行政、知识、档案、报价等核心场景，通过电子化、智能化、协同化，打破孤岛、减少重复、提升效率。这既是降本增效，更是沉淀资产、规范治理、增强响应，推动企业从人治到数治，释放生产力。
            </p>
            <router-link to="/product/ProductGLDetail" class="btn"
              >查看详情</router-link
            >
          </div>
          <div v-if="products.length === 0" class="product-card">
            <div class="product-image">
              <img src="@/assets/3.png" alt="办公与生产力软件" />
            </div>
            <h3>办公与生产力软件</h3>
            <p>
              办公与生产力软件正从辅助工具升级为业务引擎。围绕项目管理、人事、行政、知识、档案及报价等场景，以流程自动、数据贯通、智能协同的方式，减少内耗、加速响应。它不仅能降本增效，更推动经验资产化、管理规范化、决策实时化，构建敏捷可持续的生产力体系。
            </p>
            <router-link to="/product/ProductBGDetail" class="btn"
              >查看详情</router-link
            >
          </div>
        </div>
      </div>
    </section>

    <!-- 底部 -->
    <Footer v-bind="footerData" />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import api from "@/api";
import { pageDataMixin } from "@/mixins/pageData";

export default {
  name: "Products",
  components: {
    Navbar,
    Footer,
  },
  mixins: [pageDataMixin],
  data() {
    return {
      products: [],
    };
  },
  mounted() {
    this.fetchProducts();
  },
  methods: {
    fetchProducts() {
      api
        .get("/api/product/getProductList")
        .then((response) => {
          if (response.data.code === 0) {
            this.products = response.data.data;
          }
        })
        .catch(() => {
          // 静默处理错误
        });
    },
  },
};
</script>

<style scoped>
.products {
  font-family: Arial, sans-serif;
}

/* 通用样式 */
.container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
}

/* ========= Banner ========= */
.page-banner {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 4rem 0;
  text-align: center;
}
.page-banner h1 {
  font-size: 2.5rem;
  margin: 0 0 0.5rem 0;
  font-weight: 600;
}
.page-banner p {
  margin: 0;
  font-size: 1.1rem;
  opacity: 0.9;
}

/* 产品展示 */
.products-content {
  padding: 3rem 0;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.product-card {
  background-color: #f9f9f9;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  min-height: 400px;
}

.product-card:hover {
  transform: translateY(-5px);
}

.product-image {
  margin-bottom: 1rem;
}

.product-image img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
}

.product-card h3 {
  margin-bottom: 1rem;
  font-size: 1.3rem;
}

.product-card p {
  margin-bottom: 1.5rem;
  line-height: 1.6;
  flex-grow: 1;
}

.btn {
  display: inline-block;
  background-color: #007bff;
  color: white;
  padding: 0.8rem 1.5rem;
  text-decoration: none;
  border-radius: 50px;
  transition: background-color 0.3s ease;
  width: auto;
  white-space: nowrap;
  text-align: center;
}

.btn:hover {
  background-color: #0069d9;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .nav-links {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  .products-grid {
    grid-template-columns: 1fr;
  }

  .footer-content {
    flex-direction: column;
    align-items: center;
    gap: 2rem;
  }

  .footer-details {
    flex-direction: column;
    min-width: 100%;
  }

  .company-info {
    min-width: 100%;
    text-align: center;
  }

  .company-info h3,
  .company-info p {
    text-align: center;
  }

  .core-business h4 {
    text-align: center;
  }

  .core-business p,
  .contact-info p {
    text-align: center;
  }
}
</style>
